import voicesCardIcon from "@/assets/voices/filters/voices.webp";
import instrumentalsCardIcon from "@/assets/voices/filters/instrumentals.webp";
import favoritesCardIcon from "@/assets/voices/filters/favorites.webp";
import makeVoiceCardIcon from "@/assets/voices/filters/own-voice.webp";
import publicVoiceCardIcon from "@/assets/voices/filters/public.webp";

export type Filter = {
  id: string;
  title: string;
  category: string;
};

export interface CardFilter extends Filter {
  background: string;
  image: string;
}

const genderFilters: Filter[] = [
  { id: "M", title: "Male", category: "male" },
  { id: "F", title: "Female", category: "female" },
];

export const ownFilterCategoryName = "own";
export const publicFilterCategoryName = "public";

const cardFilters: CardFilter[] = [
  {
    id: "A",
    title: "Voices",
    category: "all",
    background: "linear-gradient(98.79deg, #0072FF -7.72%, #00C6FF 111.91%)",
    image: voicesCardIcon.src,
  },
  {
    id: "MI",
    title: "Instruments",
    category: "instruments",
    background: "linear-gradient(98.79deg, #FF7E5F -7.72%, #F66D9B 111.91%)",
    image: instrumentalsCardIcon.src,
  },
  {
    id: "F",
    title: "Favorites",
    category: "favourites",
    background: "linear-gradient(98.79deg, #9CECFB -7.72%, #65C7F7 111.91%)",
    image: favoritesCardIcon.src,
  },
  {
    id: "MY",
    title: "My AI Voices",
    category: ownFilterCategoryName,
    background: "linear-gradient(98.79deg, #2E0057 -7.72%, #00FFA1 111.91%)",
    image: makeVoiceCardIcon.src,
  },
  {
    id: "PUB",
    title: "Public Voices",
    category: publicFilterCategoryName,
    background: "linear-gradient(98.79deg, #570036 -7.72%, #00BBFF 111.91%)",
    image: publicVoiceCardIcon.src,
  },
];

const defaultModelFilter = { id: "A", title: "Categories", category: "all" };
const modelFilters: Filter[] = [
  // { id: "A", title: "All", category: "all" },
  { id: "S", title: "Music", category: "music" },
  { id: "C", title: "Cartoon", category: "cartoon" },
  { id: "AC", title: "Actors", category: "actors" },
  { id: "VG", title: "Video Games", category: "games" },
  { id: "FLMS", title: "Films", category: "films" },
  { id: "AN", title: "Anime", category: "anime" },
  { id: "PO", title: "Politicians", category: "politicians" },
  { id: "CE", title: "Celebrity", category: "celebrity" },
  { id: "FO", title: "Footballers", category: "football" },
  { id: "R", title: "Rap", category: "rapper" },
  { id: "P", title: "Pop", category: "pop" },
  { id: "RB", title: "R&B", category: "r&b" },
  { id: "RO", title: "Rock", category: "rock" },
  { id: "O", title: "Opera", category: "opera" },
  { id: "60s", title: "60s", category: "60s" },
  { id: "MI", title: "Music Instruments", category: "instruments" },
  { id: "F", title: "Favorites", category: "favourites" },
  { id: "MY", title: "My AI Voices", category: ownFilterCategoryName },
  { id: "PUB", title: "Public Voices", category: publicFilterCategoryName },
  // TODO add original voices, implement own models
  // { id: "O", title: "Original", category: "original" },
];

const defaultResultFilter = { id: "A", title: "All", category: "all" };
const instrumentalFilter = {
  id: "I",
  title: "Instrumentals",
  category: "instrumental",
};
const vocalFilter = { id: "V", title: "Vocals", category: "vocal" };

const emptyFilterContainer = [defaultResultFilter];

const convertFilters: Filter[] = [
  defaultResultFilter,
  { id: "C", title: "Combined", category: "combined" },
  instrumentalFilter,
  vocalFilter,
];

const stemSplitterFilters: Filter[] = [
  defaultResultFilter,
  vocalFilter,
  { id: "B", title: "Bass", category: "bass" },
  { id: "P", title: "Piano", category: "piano" },
  { id: "G", title: "Guitar", category: "guitar" },
  { id: "D", title: "Drums", category: "drums" },
  { id: "O", title: "Other", category: "other" },
];

const vocalRemoverFilters: Filter[] = [
  defaultResultFilter,
  vocalFilter,
  instrumentalFilter,
];

const ttmFilters: Filter[] = emptyFilterContainer;

const ttsFilters: Filter[] = emptyFilterContainer;

const audioHistoryFilters = {
  convertFilters,
  stemSplitterFilters,
  vocalRemoverFilters,
  ttmFilters,
  ttsFilters,
};

const $filters = {
  genderFilters,
  cardFilters,
  modelFilters,
  audioHistoryFilters,
  defaultModelFilter,
  defaultResultFilter,
};

export default $filters;
